var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, react/jsx-closing-bracket-location, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var WidgetJsonifyDeprecated = require("../mixins/widget-jsonify-deprecated.jsx");
var Renderer = require("../renderer.jsx");

var _require = require("../gorgon/proptypes.js"),
    linterContextProps = _require.linterContextProps,
    linterContextDefault = _require.linterContextDefault;

var PassageRefTarget = React.createClass({
    displayName: "PassageRefTarget",

    propTypes: _extends({}, Changeable.propTypes, {
        content: React.PropTypes.string,
        linterContext: linterContextProps
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            content: "",
            linterContext: linterContextDefault
        };
    },

    getUserInput: function getUserInput() {
        return WidgetJsonifyDeprecated.getUserInput.call(this);
    },

    render: function render() {
        return React.createElement(Renderer, {
            content: this.props.content,
            inline: true,
            apiOptions: this.props.apiOptions,
            linterContext: this.props.linterContext
        });
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    simpleValidate: function simpleValidate(rubric) {
        return PassageRefTarget.validate(this.getUserInput(), rubric);
    }
});

_.extend(PassageRefTarget, {
    validate: function validate(state, rubric) {
        return {
            type: "points",
            earned: 0,
            total: 0,
            message: null
        };
    }
});

module.exports = {
    name: "passage-ref-target",
    displayName: "PassageRefTarget",
    defaultAlignment: "inline",
    widget: PassageRefTarget,
    hidden: true,
    transform: function transform(editorProps) {
        return _.pick(editorProps, "content");
    },
    version: { major: 0, minor: 0 },
    isLintable: true
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/passage-ref-target.jsx
 ** module id = 138
 ** module chunks = 0 1
 **/